import enumFactory from "@util/enumFactory";

export default enumFactory.createEnum({

    UNKNOWN: {
        code: 0,
        title: '保密'
    },
    MALE: {
        code: 1,
        title: '男'
    },
    FEMALE: {
        code: 2,
        title: '女'
    },

});
